export default "__VITE_ASSET__Brc6KFdX__"